import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";

const saved = typeof window !== "undefined" ? window.localStorage.getItem("noam_lang") : null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
    },
    lng: saved || "fr",
    fallbackLng: "fr",
    interpolation: { escapeValue: false },
  });

export default i18n;
